<div
  class="chat-file"
  [ngClass]="{ error: file()?.status == 'error' }"
  (click)="openContextMenu($event)"
  (auxclick)="openContextMenu($event)"
  (contextmenu)="openContextMenu($event)"
>
  @if (file()?.status == 'uploading') {
    <u-icon [model]="{ type: 'font', value: 'pi pi-spin pi-spinner' }" [styles]="{ fontSize: '14px' }"></u-icon>
  } @else {
    <u-icon [model]="{ type: 'img', value: { lightUrl: file().icon } }"></u-icon>
  }
  <div
    class="file-name"
    [pTooltip]="file()?.name?.length > MAX_CHARS_FILE_NAME ? file().name : ''"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  >
    {{ fileName() }}
  </div>
  @if (viewMode() == 'edit') {
    <u-button
      fontIcon="times"
      [versionNumber]="2"
      [styleType]="'text'"
      [sizeElement]="'large'"
      (onClick)="removeFile.emit(file()?.blobId)"
      pTooltip="Remove file"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
    </u-button>
  }
</div>
